var ApiError = function (status, text) {

    this.status = status | 0;

    this.text = text;

    this.isHttp = !!arguments[2];

    this.getText = function () {
        return this.text;
    };

    this.toString = function () {
        return this.text + " - " + this.status;
    };
};

var LOG_LEVEL_NONE = 0;
var LOG_LEVEL_ERROR = 1;
var LOG_LEVEL_ALL = 2;

var api = {
    path: "/api/v2/",
    aut_key: "",
    log_level: LOG_LEVEL_ALL,
    errorHandler: function () {
    },
    multiplyErrorHandlers: [],
    sleep: 0,
    defaultSleep: 0,
    additionalParameters: {},
    setAuthKey: function (key) {
        this.auth_key = key;
    },
    removeAuthKey: function () {
        this.aut_key = "";
    },
    setErrorHandler: function (callback) {
        this.errorHandler = callback;
    },
    addErrorHandler: function (handler) {
        api.multiplyErrorHandlers.push(handler);
    },

    getError: function (status, text) {
        return new ApiError(status, text);
    },

    log: function (log) {

        if (log === null || log.length == 0) {
            return true;
        }

        var method = log.shift().trim(),
            addr = log[0].replace(api.path, "");

        var isError = !!arguments[1];

        function logResponse() {
            console.log("Response: " + log[2].status);
            console.dir(log[2].data);
        };

        if (api.log_level == api.LOG_LEVEL_NONE || (api.log_level == api.LOG_LEVEL_ERROR && !isError)) {
            return true;
        }

        if (method == "SILENT") {
            //console.log("GET " + addr);
            return true;
        }

        if (method == "GET") {
            console.groupCollapsed("GET " + addr);
            logResponse();

            console.groupEnd();
            return true;
        }

        if (method == "POST") {

            var params = log[1],
                action = params.action || "";

            console.groupCollapsed("POST " + action.toUpperCase() + " /" + addr);
            console.log("Request:");
            console.dir(params);
            logResponse();
            console.groupEnd();
            return true;
        }

    },

    getAddr: function (obj, parameters, query) {
        var getParameters = "",
            query = query || {};

        if (this.auth_key) {
            api.additionalParameters["auth_key"] = this.auth_key;
        }

        var gets = [];

        Object.each(api.additionalParameters, function (value, key) {
            gets.push(key + "=" + value);
        });
        Object.each(query, function (value, key) {
            gets.push(key + "=" + value);
        });


        if (api.sleep) {
            gets.push("sleep=" + api.sleep);
            api.sleep = api.defaultSleep;
        }

        if (gets.length > 0) {
            getParameters = "?" + gets.join("&");
        }

        api.additionalParameters = {};
        return encodeURI((api.path + obj + "/" + parameters.compact().join("/")).replace(/\/$/, "") + getParameters);
    },
    wrapWithCallbacks: function (request, log) {
        return request.then(function (response) {
            if (response.status != 200) {
                return Promise.reject(new ApiError(response.status, response.statusText, true));
            }
            return response.json();
        }).then(function (data) {
            if (data.status == 200) {
                log.push(data);
                api.log(log);
                return data.data;
            }
            return Promise.reject(new ApiError(data.status, data.data));
        }).catch(function (error) {
            //var er = new ApiError(0, error);
            log.push(error);
            api.log(log, true);
            api.errorHandler.apply(error, [error]);
            throw error;
        });
    },
    get: function (collection) {
        var parameters = arguments[1] || [],
            data = arguments[2] || {},
            url = api.getAddr(collection, parameters, data),
            skipLog = arguments[3]||false;
        var log = [skipLog? "SILENT" : "GET ", url, {}];
        return api.wrapWithCallbacks(api._get(url), log);
    },

    _get: function (url) {
        return fetch(url, {method: "GET"});
    },
    post: function (collection) {
        var parameters = arguments[1] || [],
            data = arguments[2] || {},
            url = api.getAddr(collection, parameters),
            customWrapper = arguments[3]||null;

        var urlEncodedDataPairs = [],
            name;

        var parametrize = null;
        if (!("$" in window)) {
            parametrize= function(a) {return Object.keys(a).map(function(k) {
                return encodeURIComponent(k) + '=' + encodeURIComponent(a[k])
            }).join('&')};
        } else {
            parametrize = $.param;
        }

        var body = parametrize({data: JSON.stringify(data)});

        var log = ["POST ", url, data];


        var fetchRequest = fetch(url, {
            method: "POST",
            body: body,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        });

        if (customWrapper!==null) {
            return customWrapper(fetchRequest, log);
        }

        return api.wrapWithCallbacks(fetchRequest, log);
    },
    action: function (action, collection) {
        var data = arguments[3] || {};
        data.action = action;
        return api.post(collection, arguments[2] || [], data);
    },

    download: function(action, collection) {
        var data = arguments[3] || {};
        data.action = action;
        return api.post(collection, arguments[2] || [], data, function(request, log) {

            return request.then(function (response) {
                if (response.status != 200) {
                    return Promise.reject(new ApiError(response.status, response.statusText, true));
                }

                var contentType = response.headers.get("Content-Type");

                if ((contentType||"").match(/^application\/json/)) {
                    return response.json().then(function (data) {
                        return Promise.reject(new ApiError(data.status, data.data));
                    });
                }

                return response.blob();
            }).catch(function (error) {
                log.push(error);
                api.log(log, true);
                api.errorHandler.apply(error, [error]);
                throw error;
            });;
        });
    },

    callApi: function(collection) {
        var args = Array.prototype.slice.apply(arguments);
        args.unshift("api")
        return api.action.apply(api, args);
    },

    update: function () {
        var args = Array.prototype.slice.apply(arguments);
        args.unshift("update")
        return api.action.apply(api, args);
    },
    del: function () {
        var args = Array.prototype.slice.apply(arguments);
        args.unshift("delete")
        return api.action.apply(api, args);
    },
    add: function () {
        var args = Array.prototype.slice.apply(arguments);
        args.unshift("add")
        return api.action.apply(api, args);
    },

    urls: function(urls) {
        return api.action("execute","system",['methods'],{urls: urls});
    },


    joint: function (urls) {
        var data = {
            methods: urls.map(function (stringOrMethodObject) {
                return stringOrMethodObject.method === undefined ? {method: stringOrMethodObject} : stringOrMethodObject;
            })
        };
        return api.post("system", ['joint'], {data: data});
    },
};

api.LOG_LEVEL_NONE = LOG_LEVEL_NONE;
api.LOG_LEVEL_ERROR = LOG_LEVEL_ERROR;
api.LOG_LEVEL_ALL = LOG_LEVEL_ALL;

export default api;


//////////////////
// WEBPACK FOOTER
// ../main/cdn/api/api.4.0.js
// module id = 2
// module chunks = 0